<template>
  <Btn @click.native="save" >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 15V4C12 2.89543 12.8954 2 14 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V2M12 15L9 12M12 15L15 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    Сохранить
  </Btn>
</template>

<script>
import { mapState } from 'vuex'
import Btn from './Btn.vue'
export default {
  components: { Btn },
  computed: {
    ...mapState(['stepsdata'])
  },
  methods: {
    save(){
      this.$store.dispatch('saveAll')
    }
  }
}
</script>

<style>

</style>